import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef, Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  Inject
} from '@angular/core';
import {
  IdynamicFormItem,
  IDynamicFormItemTooltipPattern,
  IDynamicFormItemTooltipWidget
} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { DynamicFormModalPayload } from '@ispm/dynamic-form/classes/dynamic-form-modal-payload.class';
import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { cloneDeep, get, isArray, findIndex, find, uniqBy as _uniqBy, assign, map as lodashMap, isEmpty, merge } from 'lodash';
import { distinctUntilChanged, filter, map, take, takeUntil } from 'rxjs/operators';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { AbstractControl, AsyncValidator, FormGroup, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { IReflect } from '@ispm/dynamic-form/interfaces/reflect.interface';
import { SearchService } from '@ispm/dynamic-form/services/search.service';
import { TAGS } from "@ispm/dynamic-form/constants/FlagTypes";
import { IDynacmiFormTableUniqueBy } from '../../interfaces/IDynacmiFormTableUniqueBy.interface';
import * as jmespath from 'jmespath';
import { IConditionalItem, ConditionalItem } from '@ispm/shared/classes/conditional-item.class';
import { FormulaService } from "@ispm/shared/services/formula.service";
import { checkConditions, getDisplayedValue, getFormItemValue } from "@ispm/dynamic-form/utilities/reflects.util";


export enum AddButtonPlacementEnum {
  lowLeftCorner = 'LOW_LEFT',
  upperRightCorner = 'UPPER_RIGHT',
  lowRightCorner = 'LOW_RIGHT',
  upperLeftCorner = 'UPPER_LEFT'
}

@Component({
  selector: 'gen-dynamic-form-table',
  templateUrl: './dynamic-form-table.component.html',
  styleUrls: ['./dynamic-form-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

@ResolvableComponent(null, 'DynamicFormTable')
export class DynamicFormTableComponent implements OnInit, IWidgetItem, AfterContentInit {

  public set widgetDisabledStatus(disabled: boolean) {
    this.disabled = disabled;
  }

  @Input()
  emitFormChangeEvenIfInvalid: boolean = false;
  //this input to stop propagation of update at init stage Use only in events external links.
  @Input()
  skipInit: boolean;
  @Input()
  skipWidgetUpdateValueCallback: boolean = false;
  @Input()
  titleClass: string = '';
  private skipasyncValidation:boolean = false;
  private configName:string;
  private addRowWhenNoData: boolean = false;
  private deleteRow: boolean = false;
  public _emptyMessageDisplay$ =  new BehaviorSubject<any>(undefined);
  @Input()
  displayLabelItem : boolean = false;

  set widgetConfig(_itemConfig: IdynamicFormItem<DynamicFormModalPayload>) {
    const widgetPayload = _itemConfig.widgetPayload;
    this._isWidget = true;
    Object.assign(this, widgetPayload);// TODO variable which has setters shoulld not be created again.
    this.formContext = widgetPayload.updatedFieldsContext;

    if (widgetPayload.formId) { // formid would be  null in the store without this
      this.formId = widgetPayload.formId;
    }
    if (widgetPayload.formConfig) {
      this.formItems = widgetPayload.formConfig;
    } else {
      this.resolveFormById();
    }

    if (widgetPayload.additional) {
      this.showTitlesIfEmpty = widgetPayload.additional.showTitlesIfEmpty == false ? false : true;
      this.emptyMessageDisplay = widgetPayload.additional.emptyMessageDisplay;
      this.hideTitles = widgetPayload.additional.hideTitles;
      this.displayEmptyRows = widgetPayload.additional.displayEmptyRows == false ? false : true;
      this.emptyRowConditions = widgetPayload.additional.emptyRowConditions ? widgetPayload.additional.emptyRowConditions : [];
      this.addRowWhenNoData = widgetPayload.additional.addRowWhenNoData ? widgetPayload.additional.addRowWhenNoData : false;
    }

    if (widgetPayload.formReflects) {
      this.formReflects = widgetPayload.formReflects;
    }

    if (this.formItems) {
      this._formHandler.addForm(this.formId, this.formItems);
    }

    const asyncValidate = new DynamicFormTableValidator(() => this.validationStatus.every(v => v));
    this.skipasyncValidation = _itemConfig.widgetPayload.skipAsyncValidation;
    this.configName = _itemConfig.name;
    this.titleClass = get(widgetPayload, 'tableTitleCssClass', this.titleClass);
    this.displayLabelItem = get(widgetPayload, 'displayLabel', this.displayLabelItem);

    if (!(_itemConfig.widgetPayload.skipAsyncValidation)) {
      let asyncValidatorsArray = [];
      asyncValidatorsArray.push(asyncValidate.validate.bind(asyncValidate));
      if (this.minItemSelection) {
        const asyncValidateMinItemSelection = new DynamicFormTableValidator(() => this.itemsSelectionCount >= this.minItemSelection);
        asyncValidatorsArray.push(asyncValidateMinItemSelection.validate.bind(asyncValidateMinItemSelection));
      }
      if (widgetPayload.allowDuplicate != undefined && !widgetPayload.allowDuplicate) {
        const asyncValidateDisAllowDuplicate = new DynamicFormTableValidator(() => {
            let fieldValuesArray = this.widgetFormInstance.controls[_itemConfig.name].value;
            const fieldName = widgetPayload.validateDuplicateByField;
            fieldValuesArray = fieldValuesArray.map((item) => item[fieldName]);
            return fieldValuesArray.length === new Set(fieldValuesArray).size;
          },
          widgetPayload.note
        );
        asyncValidatorsArray.push(asyncValidateDisAllowDuplicate.validate.bind(asyncValidateDisAllowDuplicate));
      }

      this.widgetFormInstance.controls[_itemConfig.name].setAsyncValidators(asyncValidatorsArray);
    } else {
      this.widgetFormInstance.controls[0].setAsyncValidators([asyncValidate.validate.bind(asyncValidate)]);
    }

  }

  set widgetData(widgetData: any) {
    if (widgetData && !Array.isArray(widgetData)) {
      // for  priority table to work
      delete widgetData[TAGS.TAG_MODIFIED];
      widgetData = (<any>Object).values(widgetData);
      this._changeDetector.markForCheck();
    }
    if (this.defaultValueSet || this.defaultValues) {
      if (JSON.stringify(widgetData) !== JSON.stringify(this.data)) {
        this.data = [];
        if (this.defaultValueSet) {
          this._search.query(this.defaultValueSet, '').subscribe(function (_defaultValues) {
            this.prepareDataWithDefaultItems(widgetData, _defaultValues);
          }.bind(this));
        } else if (this.defaultValues) {
          this.prepareDataWithDefaultItems(widgetData, this.defaultValues);
        }
      }
    } else {
      this.data = widgetData;
    }
    if (this.itemSelection && this.maxItemSelection > 1) {
      this.updateItemSelectionCount();
    }
    // Without this validation isn't working but component slows
    // Asyncvalidator becoming null even after set in set widget config
    const asyncValidate = new DynamicFormTableValidator(() => this.validationStatus.every(v => v));
    if (!(this.skipasyncValidation)) {
      if (!(this.widgetFormInstance.controls[this.configName].asyncValidator)) {
        this.widgetFormInstance.controls[this.configName].setAsyncValidators([asyncValidate.validate.bind(asyncValidate)]);
      }
    }
    else if (!this.widgetFormInstance.controls[0].asyncValidator) {
      this.widgetFormInstance.controls[0].setAsyncValidators([asyncValidate.validate.bind(asyncValidate)]);
    }
    this._changeDetector.markForCheck();
  }

  set widgetFormInstanceSubmitted(submitted: boolean) {
    this.submitted = submitted;
  }

  @Input()
  set formItems(formItems: Array<IdynamicFormItem>) {
    this.buildFormTitles(formItems);
  }

  get formItems() {
    return this._formItems;
  }

  public static readonly ITEM_SPECIFIC_NG_CLASS_PROPRTY = '__DF_TABLE_ITEM_NG_CLASS';
  public readonly ITEM_SPECIFIC_SELECTION_PROPERTY = 'selected';
  public titles: Array<{ label: string, required?: boolean }>;
  public widgetUpdateValueCallback: (value) => void;
  public uniqueButtonName: string;
  public widgetFormInstance: FormGroup;
  private _isWidget: boolean = false;
  private formContext: string;

  @ViewChild('cloneEvent', { static: false, read: ViewContainerRef }) private cloneEventRef: ViewContainerRef;
  private deleteAvailableByField: string;
  private deleteDisableByField: string;
  private deleteFieldModelName: string;

  @ViewChild('deleteEvent', { static: false, read: ViewContainerRef }) private deleteEventRef: ViewContainerRef;
  @ViewChild('row', { static: false, read: ViewContainerRef }) private rowRef: ViewContainerRef;

  @Input() addButtonText: string = '';
  @Input() addButtonPlacement: string = AddButtonPlacementEnum.lowLeftCorner;
  private _destroyer: Subject<void> = new Subject();

  @Input()
  private schema: any = {};

  @Input() submitted: boolean = false;

  @Input()
  listenToFormConfigChanges: boolean;

  @Input()
  isExtraRow: boolean = false;

  @Input()
  public set emptyMessageDisplay(data) {
    setTimeout(()=>{
      this._emptyMessageDisplay$.next(data);
    },2000)

  }

  @Input()
  public showTitlesIfEmpty: boolean = true;
  applyCssClass: string;
  validationStatus: boolean[] = [];
  formReflects: IReflect[] = [];
  @Output()
  initEmitter: EventEmitter<any> = new EventEmitter<any>();


  // set widgetConfig(_itemConfig: IdynamicFormItem<DynamicFormModalPayload>) {
  //   const widgetPayload = _itemConfig.widgetPayload;
  //   this._isWidget = true;
  //   Object.assign(this, widgetPayload);
  //   this.formContext = widgetPayload.updatedFieldsContext;
  //   if (widgetPayload.formConfig) {
  //     this.formItems = widgetPayload.formConfig;
  //   } else {
  //     this.resolveFormById();
  //   }
  //   if (this.formItems) {
  //     this._formHandler.addForm(this.formId, this.formItems);
  //   }
  //   const asyncValidate = new DynamicFormTableValidator(() => this.validationStatus.every(v => v));
  //   this.skipasyncValidation = _itemConfig.widgetPayload.skipAsyncValidation;
  //   this.configName = _itemConfig.name;
  //   this.titleClass = get(widgetPayload, 'tableTitleCssClass', this.titleClass);
  //   if (!(_itemConfig.widgetPayload.skipAsyncValidation)) {
  //     let asyncValidatorsArray = [];
  //     asyncValidatorsArray.push(asyncValidate.validate.bind(asyncValidate));
  //     if (this.minItemSelection) {
  //       const asyncValidateMinItemSelection = new DynamicFormTableValidator(() => this.itemsSelectionCount >= this.minItemSelection);
  //       asyncValidatorsArray.push(asyncValidateMinItemSelection.validate.bind(asyncValidateMinItemSelection));
  //     }
  //     this.widgetFormInstance.controls[_itemConfig.name].setAsyncValidators(asyncValidatorsArray);
  //   } else {
  //     this.widgetFormInstance.controls[0].setAsyncValidators([asyncValidate.validate.bind(asyncValidate)]);
  //   }
  // }

  @Input()
  public validationStatusRef: (validationStatus: boolean[]) => void;

  @Input()
  public hideTitles: boolean = false;

  /**
   * add to the diff field map on value update
   */
  @Input()
  public flagDiffFieldsOnUpdate: boolean = false;

  @Input()
  public uniqueBy: IDynacmiFormTableUniqueBy;

  /**
   * indicates if to allow changing order of rows in the table
   */
  @Input()
  public prioritizeAvailable: boolean = false;

  public isPrioritizeAvailable(): boolean {
    return this.prioritizeAvailable && !this.disabled;
  }

  @Input()
  public displayEmptyRows: boolean = true;

  public emptyRowConditions: Array<IConditionalItem> = [];

  /**
   * set the field by which the data in table's rows will be sorted when <prioritizeAvailable> is enabled.
   * if no specific field is provided, the data will be sorted by temporary unique identifier that is associated to each
   *  element (see: selection-list.component.ts)
   */
  @Input()
  public prioritizeTrackByField: string;

  /**
   * indicates if data should be displayed as a table list (value = true - labels are displayed in columns) or a as
   *  label-text fields (value = false)
   *
   *  (-) table view:
   *      label1 | label2 | label3 | label4 | label5 | ....
   *      ------ | ------ | ------ | ------ | ------ | ----
   *      field1 | field2 | field3 | field4 | field5 | ....
   *
   *  (-) non-table view:
   *      label1: field1
   *      label2: field2
   *      label3: field3
   *      ....
   */
  @Input() viewAsTable: boolean = true;

  /**
   * indicates if to display the form items within dynamic-form.component in multiple rows (value = true) or in one row (value = false)
   *
   *  (-) formVertical TRUE:
   *      label1: field1
   *      label2: field2
   *      label3: field3
   *      label4: field4
   *      ....
   *
   *  (-) formVertical FALSE:
   *      label1: field1    label2: field2    label3: field3    label4: field4 ....
   */
  @Input() formVertical: boolean = false;

  /**
   * indicates if to display the form items within a table's row in a single column (value = true) or in 2 separate
   *  columns (value = false)
   *
   *  (-) tableVertical TRUE (formVertical = FALSE, viewAsTable = FALSE):
   *      label1: field1  label2: field2   label3: field3   label4: field4 ....
   *
   *  (-) tableVertical TRUE (formVertical = FALSE, viewAsTable = TRUE):
   *      label1 | label2 | label3 | label4 | label5 | ....
   *      ------ | ------ | ------ | ------ | ------ | ----
   *      field1 | field2 | field3 | field4 | field5 | ....
   *
   *  (-) tableVertical TRUE (formVertical = TRUE, viewAsTable = TRUE):
   *      label1 | label2 | label3 | label4 | ....
   *      field1
   *      field2
   *      field3
   *      field4
   *      ....
   *
   *  (-) tableVertical FALSE (formVertical = FALSE, viewAsTable = FALSE):
   *      label1: field1    label2: field2
   *      label3: field3    label4: field4
   *
   *  (-) tableVertical FALSE (formVertical = FALSE, viewAsTable = TRUE):
   *      label1 | label2 | label3 | label4 | ....
   *      field1    field2
   *      field3    field4
   *      ....
   *
   *  (-) tableVertical FALSE (formVertical = TRUE, viewAsTable = TRUE):
   *      label1 | label2 | label3 | label4 | ....
   *      field1
   *      field2
   *      field3
   *      field4
   *      ....
   */
  @Input() tableVertical: boolean = true;

  @Input()
  public set data(data) {
    this._data = data;

    if (this.uniqueBy) {
      this._data = _uniqBy(this._data, (item) => {
        return this.uniqueBy.paths.map(path => {
          try {
            return jmespath.search(item, path);
          } catch (err) {
            // the search function will throw an error if it is not able to complete the search for any reason
            return '';
          }
        }).join('');
      });
    }

    if (this.emptyRowConditions && this.emptyRowConditions.length > 0) {
      this._data = this.filterEmptyRows();
    }
  }

  public get data() {
    return this._data;
  }

  private _data: Array<any>;

  @Input()
  defaultTabletitle: any;

  @Input()
  public formItemFullWidth: boolean = false;

  @Input()
  public formHalfWidth: boolean = false;

  private _formItems: Array<IdynamicFormItem>;

  @Input()
  public formId;

  // indicates if fields in rows appear in Edit mode (as input fields)
  @Input()
  public editMode: boolean = false;

  @Input()
  public listenToDataChange: boolean;

  // indicates if to show the 'Add' new item command. Button is added if true and if form is not disabled
  @Input() showAddButton: boolean = false;

  // indicates if to show the 'Delete' item icon. Icon is added, per an item, if true and if both form & item are not disabled
  @Input() showDeleteButton: boolean = false;

  // indicates if element should be posed on-top of other elements. For example, for a SELECT element to be displayed over
  //  other elements (so the list will not be hided below other elements) - set this parameter to <true>
  @Input()
  public popupMode: boolean;

  // indicates if table is for read-only and its data cannot be modified
  @Input()
  public disabled: boolean;

  /**
   * holds a reference to a function that defines the fields context of a specific form-table-item.
   * this referenced-method is invoked in getItemUpdateContext() method
   */
  @Input()
  public updatedFieldsContextRef: (item: any) => string;

  /**
   * holds a reference to a function that is invoked when the validation-event is called for a specific form-table-item.
   * this referenced-method is invoked in validationEvent() method
   */
  @Input()
  public itemValidationEventRef: (valid: boolean, item: any) => void;

  // set if to disabled the Add command (if it is displayed anyhow)
  @Input() disableAddButton: boolean = false;

  /**
   * set the title to display on the table list
   */
  @Input() tableTitle: string = '';

  /**
   * set the title of an individual item on the list. This title is used on the actions that are related to this item
   */
  @Input() itemTitle: string = 'item';

  /**
   * holds a reference to a function that is invoked to get the ngClass of a specific form-table-item.
   * this referenced-method is invoked in itemNgClass() method
   */
  @Input() itemNgClassRef: (item: any) => any;

  /**
   * holds a reference to a function that indicates if to remove a specific form-table-item from the data list when Delete
   *  command is being operated.
   * this referenced-method is invoked in emitDeleteItem() method
   */
  @Input() removeItemOnDeleteRef: (item: any) => boolean;

  /**
   * holds a reference to a function to indicate if a specific form-table-item should be disabled.
   * this referenced-method is invoked in itemDisabled() method
   */
  @Input() isItemDisabledRef: (item: any) => boolean;

  /**
   * holds a reference to a function to indicate if a specific form-table-item is in edit mode enabled.
   * this referenced-method is invoked in itemEditMode() method
   */
  @Input() isItemEditModeRef: (item: any) => boolean;

  /**
   * holds a reference to a function to indicate if to update a specific form-table-item on blur
   * this referenced-method is invoked in itemUpdateOnBlur() method
   */
  @Input() itemUpdateOnBlurRef: (item: any) => boolean;

  /**
   * holds a reference to a function to allow overriding the display of a specific row
   * this referenced-method is invoked in itemOverrides() method
   */
  @Input() itemOverridesRef: (item: any) => any;

  /**
   * holds a reference to a function to indicate if a specific form-table-item should be submitted
   * this referenced-method is invoked in itemSubmitted() method
   */
  @Input() itemSubmittedRef: (item: any) => boolean;

  /**
   * holds a reference to a function to indicate if the specific item can be deleted
   * this referenced-method is invoked in isDeleteItemAvailable() method
   */
  @Input() canDeleteItemRef: (item: any) => boolean;

  // holds the message to disaply on a required form-table-item
  @Input() itemRequiredMessage: string;

  /**
   +   * holds a reference to a function to indicate if a specific form-table-item is added
   +   * this referenced-method is invoked in emitAddItem() method
   +   */
  @Input() itemAddRef: (item: any) => boolean;

  /**
   * emits an event when the data list is being updated, either when a specific item's value is changed or the list is
   *  re-ordered (invoked in emitUpdate())
   */
  @Output()
  itemUpdateEmitter: EventEmitter<any> = new EventEmitter<any>();

  /**
   * emits an event when an item is being deleted from the list (invoked in emitDeleteItem())
   */
  @Output()
  itemDeletedEmitter: EventEmitter<any> = new EventEmitter();

  /**
   * emits an event when a new item is being added to the list (invoked in emitAddItem())
   */
  @Output()
  itemAddEmitter: EventEmitter<any> = new EventEmitter();

  /**
   * emits an event when an item is being cloned (invoked in emitCloneItem())
   */
  @Output()
  itemCloneEmitter: EventEmitter<any> = new EventEmitter();

  /**
   * emits an event when an item is being clicked (invoked in emitClickItem())
   */
  @Output()
  itemClickEmitter: EventEmitter<any> = new EventEmitter();

  @Input()
  public cloneAvailable: boolean = false;

  // Whether to clone the item here, or leave it to the clone event listener in a higher-level component
  // This flag allows the container to control whether or not it should do the cloning on its own.
  @Input()
  public applyClone: boolean = false;

  // This flag allows the to select row.
  @Input()
  public itemSelection: boolean = false;

  // This param helps to specify maximum items selection in table.
  // This will work only when itemSelection is true
  // If maxItemSelection is 1 toggle switch feature will be enabled between the items.
  // If maxItemSelection is empty user can select all the rows no limitation.
  @Input()
  public maxItemSelection: number;

  // This param helps to specify minimum items selection in table.
  // This will work only when itemSelection is true
  // If minItemSelection is configured and user not selected minimum item selection this dynamicFormtable validation will return false.
  @Input()
  public minItemSelection: number;

  // This param helps to specify default values to table.
  @Input()
  public defaultValues: [];

  // This param helps to specify default values from valueset to table.
  @Input()
  public defaultValueSet: string;

  // This param helps to add extra params to each item in table.
  @Input()
  public additionalParams: any;

  // This param helps to merge with default values based on this param.
  @Input()
  private mappingParamWithDefault: string;

  @Input()
  public hideMaxItemSelectionText: boolean = false;

  private itemsSelectionCount: number = 0;

  @Input()
  public tooltipText: string;

  @Input()
  public tooltipShow: boolean;

  @Input()
  public tooltipConfiguration: IDynamicFormItemTooltipPattern | IDynamicFormItemTooltipWidget;

  //These param helps to highlight the row based on row item value
  @Input()
  public customizeRowClassConfig: { rowKey: string, cssClass?: string };
  @Input()
  public availableCustomClassBasedOn: string;

  /**
   * indicates if to allow adding items to the table
   */
  public isAddItemsAvailable() {
    return this.showAddButton && !this.disabled;
  }
  constructor(private _formHandler: FormHandlerService,
              private _changeDetector: ChangeDetectorRef,
              private _search: SearchService) {
  }

  /**
   * indicates if to allow deleting items in the table
   * if <item> is provided, the method returns the result for this specific item.
   * if <item> is NOT provided, the method returns the result for the whole items.
   */
  public isDeleteItemAvailable(item?) {

    const canDelete = this.showDeleteButton && !this.disabled;
    if (!canDelete) { return false; }

    // invoke the function that is referred by canDeleteItemRef, to indicate if the specific item can be deleted.
    if (item && this.canDeleteItemRef) {
      return this.canDeleteItemRef(item);
    }

    if (this.deleteFieldModelName) {
      return true;
    }

    if (item && get(item, this.deleteAvailableByField)) {
      return true;
    }

    if (item && get(item, this.deleteDisableByField)) {
      return false;
    }

    return true;
  }

  public isCloneAvailable(): boolean {
    return this.cloneAvailable && !this.disabled;
  }

  ngAfterContentInit() {
    if (this.isExtraRow && this.showDeleteButton) {
      if (!Array.isArray(this.data)) {
        this.emitAddItem(true);
      }
      else if (Array.isArray(this.data) && this.data.length === 0) {
        this.emitAddItem(true);
      }
    }
    else
    if(this.addRowWhenNoData && this.data === undefined) {
      this.emitAddItem(true);
    }
  }

  resolveFormById() {
    this._formHandler.getStoredReflectsByFormId(this.formId).pipe(
      take(1),
      distinctUntilChanged())
      .subscribe((formReflects: IReflect[]) => {
        this.formReflects = formReflects;
      });
    let resolver = this._formHandler.getStoredFormConfigs().pipe(
      takeUntil(this._destroyer.asObservable()),
      map(formConfigs => {
        if (formConfigs.has(this.formId)) {
          return formConfigs.get(this.formId);
        } else {
          this._formHandler.getForm(this.formId);
          return null;
        }
      }),
      distinctUntilChanged(),
      filter(config => !!config)
    );

    if (!this.listenToFormConfigChanges) {
      resolver = resolver.pipe(take(1));
    }

    resolver.subscribe(_formItems => {
      this.buildFormTitles(_formItems);
    });
  }

  ngOnInit() {
    this.uniqueButtonName = 'Auto_new-button_' + this.formId;

    if (!this._isWidget) {
      if (this.formItems) {
        this.buildFormTitles(this.formItems);
      } else if (this.formId) {
        this.resolveFormById();
      }
      else {
        console.error('please provide form Id or form configuration to dynamic form table component, data:', this.data);
      }
    }

  }

  ngOnDestroy(): void {
    this._destroyer.next();
    this._destroyer.complete();
  }
  // TODO Used also for formInit,currently skipped Init for PriorityWidget.Need to be Fixed.
  /**
   * this event is invoked when a specific item's value is changed
   */
  updateItemValue(item, newValue: any, fromInit = false) {
    // Set modified to true if not from formInit
    if (this.isExtraRow) {
      newValue[TAGS.TAG_MODIFIED] = !fromInit;
    }
    if(this.data && this.data.length > 0){
      const index = this.data.findIndex(dataItem => dataItem === item);
      if(index !== -1){
        Object.assign(this.data[index], newValue);
      }
    }
    this.data = [...this.data];
    this.emitUpdate(fromInit);
    if (!this.skipInit && (!fromInit || this.skipInit))
      this.emitUpdate();
  }

  /**
   * this event is invoked when the list is re-ordered
   */
  orderChanged(newOrder) {
    this.data = newOrder;
    this.emitUpdate();
  }

  emitUpdate(isFormInit: boolean = false) {
    //TODO Used also for formInit,currently skipped Init for PriorityWidget.Need to be Fixed.
    if (isFormInit && this.skipInit){
      return;
    }
    this.initEmitter.emit(isFormInit);
    this.itemUpdateEmitter.emit(this.data);

    if (this.widgetUpdateValueCallback && !this.skipWidgetUpdateValueCallback && !isFormInit) {
      this.widgetUpdateValueCallback.apply(this, [this.data]);
    }
  }

  private filterEmptyRows() {
    if (Array.isArray(this._data)) {
      return this._data.filter(dataItem => {
        return this.emptyRowConditions.every(condition => ConditionalItem.from(dataItem, <ConditionalItem>condition).verify());
      });
    } else {
      return this._data;
    }
  }

  private buildFormTitles(formItems) {

    // if it is indicated to display fields as a label-field line, do not clear the fields' label
    this.applyCssClass = '';
    if (!this.viewAsTable) { return; }

    formItems = cloneDeep(formItems);
    this.titles = [];

    if (this.defaultTabletitle) {
      this.titles = this.defaultTabletitle;
    } else {
      formItems.forEach(formItem => {
        //Check if there are any conditions here which set the cssClass to 'hidden-form-item'
        let skipTitle = false;
        if (formItem.reflects){
          let potentialHiddenStyleReflect = find(formItem.reflects, {'styleClass': 'hidden-form-item'});
          if(potentialHiddenStyleReflect){

            skipTitle = this.data?.every((tableRow) => {
              const itemValue = getFormItemValue(tableRow, formItem);
              const validateValue = potentialHiddenStyleReflect.pathToCheck
                ? get(itemValue, potentialHiddenStyleReflect.pathToCheck, null)
                : getDisplayedValue(itemValue, formItem);

              return checkConditions(potentialHiddenStyleReflect, validateValue);
            });
          }
        }
        if ((formItem.label || formItem.label === " ") && !skipTitle) {
          this.titles.push({
            label: formItem.label,
            required: formItem.required ? formItem.required : false
          });
        }
        formItem.label = '';
      });
      this.formId = null; // TODO Identify why form reinstantiate in PT so added in else as defaultTitle is used by PT
    }
    if(!this.displayLabelItem){
      this.applyCssClass = 'df-hide-labels';
    }

    this._formItems = formItems;
  }

  /**
   * this event is invoked when the Clone action is called, per a row's datadyna
   */
  emitCloneItem(item, index) {
    // If its archived no clone
    if (item[this.deleteFieldModelName]) {
      return;
    }
    if (this.cloneEventRef) {
      if (this.applyClone) {
        item = cloneDeep(item);
        this.data.splice(index + 1, 0, item);

      }
      const event = new CustomEvent('CloneEvent', { bubbles: true, detail: item });
      this.cloneEventRef.element.nativeElement.dispatchEvent(event);
      this.emitItemArrayChangedEvent(this.itemCloneEmitter, item);
    }
  }

  /**
   * this event is invoked when the Delete action is called, per a row's data
   */
  emitDeleteItem(item) {

    // invoke removeItemOnDeleteRef function to indicate if to remove the item from the data list so
    //  (by default, item is removed)
    if ((item.hasOwnProperty(this.deleteDisableByField) || item.hasOwnProperty(this.deleteAvailableByField)) && (this.deleteFieldModelName)) {
      item[this.deleteFieldModelName] = item[this.deleteFieldModelName] ? !item[this.deleteFieldModelName] : true;
      item[TAGS.TAG_MODIFIED] = true;
      const index = this.data.findIndex(dataItem => dataItem === item);

      this.data[index] = item;
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
      this.emitUpdate();

    }
    else if (
      this.removeItemOnDeleteRef == undefined || this.removeItemOnDeleteRef == null || this.removeItemOnDeleteRef(item)
    ) {

      const index = this.data.findIndex(dataItem => dataItem === item);
      this.data.splice(index, 1);
      if (this.data.length == 0)
        this.validationStatus.pop()
    }
    // emit an event with the deleted item and the updated data list
    // delete this.validationStatus[this.validationStatus.length];
    this.deleteRow = true;
    this.emitItemArrayChangedEvent(this.itemDeletedEmitter, item);
  }

  /**
   * this event is invoked when the Add action is called, to add a new item to the table list
   */
  emitAddItem(defaultRow: boolean = false) {
    this.data = this.data || [];

    // check if the schema is a class with constructor (function) if so create a new instance
    const newObject = typeof this.schema === 'function'
      ? new this.schema()
      : { ...this.schema };
    if (this.isExtraRow) {
      Object.defineProperty(newObject, TAGS.TAG_MODIFIED, {
        enumerable: false,
        value: false,
        writable: true,
        configurable: true
      });
    }
    this.data.push(newObject);
    // Making empty row default valild true this will change if formUpdate happens
    this.validationStatus[this.data.length - 1] = true;
    this.data = [...this.data];
    // emit an event with the new added item and the updated data list
    if (this.itemAddRef) {
      this.itemAddRef(newObject);
    }
    this.emitItemArrayChangedEvent(this.itemAddEmitter, newObject);

    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();

    // Scroll only when its explicit user plus click
    // Until change detection happened rowRef undefined
    // TODO only if out of view port
    /*  if((this.rowRef.element)&&(!defaultRow)){
     this.scroll(this.rowRef.element.nativeElement);
    }*/

    /* TODO Below line for new added row validation trigger
       without item blur*/
    /*  if (this.itemValidationEventRef) {
        this.itemValidationEventRef(false, newObject);
      }
      this.emitUpdate();*/

  }

  private emitItemArrayChangedEvent(eventEmitter: EventEmitter<any>, item) {
    this._changeDetector.markForCheck();

    eventEmitter.emit({ item: item, dataArray: this.data, rowData: this._formItems });

    if ((this.deleteEventRef) && (!this.deleteFieldModelName)) {
      this.validationStatus.pop();
      const deleteData = { item: item, dataArray: this.data };
      const event = new CustomEvent('DeleteEvent', { bubbles: true, detail: deleteData });
      if(this.deleteRow) {
        this.deleteEventRef.element.nativeElement.dispatchEvent(event);
      }
    }

    if (this.validationStatusRef) {
      return this.validationStatusRef(this.validationStatus);
    }
    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [this.data]);
    }
  }

  getItemUpdateContext(item) {
    // invoke the function that is referred by updatedFieldsContextRef, to retrieve the related update context for the given item
    if (this.updatedFieldsContextRef) {
      return this.updatedFieldsContextRef(item);
    }
    return this.formContext;
  }

  validationEvent(valid: boolean, item, index: number) {
    // invoke the function that is referred by itemValidationEventRef, to validate the given item when validation-event is called
    this.validationStatus[index] = valid;

    if ((!item[TAGS.TAG_MODIFIED]) && (this.isExtraRow)) {
      this.validationStatus[index] = true;
      //  valid = true;
    }
    // this.emitUpdate();
    if (this.rowRef) {
      const event = new CustomEvent('RowValidationEvent', { bubbles: true, detail: { valid: valid, item: item, index: index } });
      this.rowRef.element.nativeElement.dispatchEvent(event);
    }
    // }
    // }
    if (this.itemValidationEventRef) {
      this.itemValidationEventRef(valid, item);
    }
    if (this.validationStatusRef) {
      return this.validationStatusRef(this.validationStatus);
    }
    if (this.widgetFormInstance) {
      this.widgetFormInstance.updateValueAndValidity({ emitEvent: true });
    }
  }

  itemDisabled(item): boolean {
    // invoke the function that is referred by isItemDisabledRef, to indicate if the specific item should be disabled.
    if (this.isItemDisabledRef) {
      return this.isItemDisabledRef(item);
    }

  }

  itemDeletedOrDisabled(item): boolean {
    if (this.isItemDisabledRef) {
      return this.isItemDisabledRef(item);
    }

    // Making disabled triggering another cycle of validation
    /*  if(this.deleteFieldModelName && item[this.deleteFieldModelName]){
        return true;
      }*/
    return this.disabled;

  }

  itemOverrides(item): any {
    // invoke the function that is referred by itemOverridesRef, to allow overriding the display of a specific row.
    if (this.itemOverridesRef) {
      return this.itemOverridesRef(item);
    }

    return undefined;
  }

  itemEditMode(item): boolean {
    // invoke the function that is referred by isItemEditModeRef, to indicate if the specific item is editable (edit mode enabled).

    // Table should always look as editMode = true when its disabled (GEN-29362)
    if (this.isItemEditModeRef) {
      return this.isItemEditModeRef(item) || this.disabled;
    }

    return this.editMode || this.disabled;
  }

  itemUpdateOnBlur(item: any): boolean {
    // invoke the function that is referred by itemUpdateOnBlurRef, to indicate if to update the specific item on blur
    if (this.itemUpdateOnBlurRef) {
      return this.itemUpdateOnBlurRef(item);
    }

    return null; // same default as in dynamic-form-component
  }

  private scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  itemSubmitted(item: any): boolean {
    // invoke the function that is referred by itemSubmittedRef, to indicate if the specific item should be submitted
    if ((this.isExtraRow) && (!item[TAGS.TAG_MODIFIED])) {
      return false;
    }
    if (this.itemSubmittedRef) {
      return this.itemSubmittedRef(item);
    }

    return this.submitted;  // same default as in dynamic-form-component
  }

  hasInlineAction(): boolean {
    // Note: the availability of actions may be changed after paged was loaded (see: GEN-32581)
    return this.isPrioritizeAvailable() || this.isDeleteItemAvailable();
  }

  itemNgClass(item: any) {
    let ngClass;

    // invoke the function that is referred by itemNgClassRef, to get the ngClass of the given item
    if (this.itemNgClassRef) {
      ngClass = this.itemNgClassRef(item);
    }

    if (!ngClass) {
      ngClass = {};
    }

    // set different table-row class, depending if row is displayed with actions or not (the row occupies different size
    //  with/wo actions)
    if (this.hasInlineAction() === true) {
      ngClass['dynamic-form-table-data-row-with-actions'] = true;
    } else if (this.viewAsTable === true) {
      ngClass['dynamic-form-table-data-row'] = true;
    }

    if (this.deleteFieldModelName && (item[this.deleteFieldModelName] === true)) {
      ngClass = { 'dynamic-form-item-deleted': true, 'diff_marker': true };
    }

    // if the data in the table row should be displayed vertically (that is, in 1 column), add the following style -
    //  this style enforces one row display
    if (this.tableVertical !== false) {
      ngClass['dynamic-form-table-vertical-items'] = true;
    }
    Object.assign(ngClass, item[DynamicFormTableComponent.ITEM_SPECIFIC_NG_CLASS_PROPRTY]);

    return ngClass;
  }

  /**
   *
   */
  get isItemSelectionAvailable(): boolean {
    return this.itemSelection;
  }

  /**
   *
   */
  get isItemSelectionDisabled(): boolean {
    return this.itemSelection && this.disabled;
  }

  /**
   *
   * @param item
   */
  isMultipleItemSelectionDisabled(item): boolean {
    if (this.maxItemSelection) {
      return this.itemsSelectionCount >= this.maxItemSelection && !get(item, this.ITEM_SPECIFIC_SELECTION_PROPERTY);
    }
    return this.disabled;
  }

  /**
   * Based on selection set ITEM_SPECIFIC_SELECTION_PROPERTY param value
   * If maxItemSelection = 1; Toggle between the table rows feature will be allowed
   * If maxItemSelection not configured and itemSelection is true all the table rows are selectable
   * If maxItemSelection is greater than 1 for example 5 only user can choose 5 table rows
   * @param item
   * @param newValue
   */
  emitItemSelection(item, newValue) {
    if (this.maxItemSelection) {
      if (this.maxItemSelection === 1) {
        this.data = lodashMap(this.data, dataItem => {
          dataItem[this.ITEM_SPECIFIC_SELECTION_PROPERTY] = false;
          return dataItem;
        });
        item[this.ITEM_SPECIFIC_SELECTION_PROPERTY] = newValue;
      } else if (this.maxItemSelection > 1) {
        newValue ? this.itemsSelectionCount++ : this.itemsSelectionCount--;
      }
    }
    item[TAGS.TAG_MODIFIED] = true;
    this.data = [...this.data];
    this.emitItemArrayChangedEvent(this.itemUpdateEmitter, item);
  }


  /**
   * Prepare table data if default values configured
   */
  private prepareDataWithDefaultItems(_widgetData, _defaultValues) {
    if (Array.isArray(_defaultValues) && _defaultValues.length > 0) {
      _defaultValues.forEach(defaultValue => {
        this.data.push({ ...defaultValue });
      });
    }
    if (_widgetData && isArray(_widgetData) && _widgetData.length > 0) {
      let tempData = [];
      if (Array.isArray(this.data) && this.data.length > 0) {
        this.data.forEach(defaultValue => {
          tempData.push({ ...defaultValue });
        });
      }
      _widgetData.forEach(function (widgetItem) {
        let defaultItemIndex = findIndex(tempData, function (item) {
          return get(item, this.mappingParamWithDefault) === get(widgetItem, this.mappingParamWithDefault) && (!get(item, 'id') || get(item, 'id') === get(widgetItem, 'id'));
        }.bind(this));
        if (defaultItemIndex >= 0) {
          let tempRowData = this.data[defaultItemIndex];
          this.data[defaultItemIndex] = assign(tempRowData, widgetItem);

        } else {
          this.data.push(widgetItem);
        }
      }.bind(this));
    }
    if (this.additionalParams) {
      this.data = this.addAdditionalParams();
    }
  }

  /**
   * Add additional parameter to each item
   */
  private addAdditionalParams() {
    return lodashMap(this.data, function (item) {
      if (item[this.ITEM_SPECIFIC_SELECTION_PROPERTY]) {
        this.itemsSelectionCount++;
      }
      return assign(item, this.additionalParams);
    }.bind(this));
  }

  /**
   * Update total item selection count
   */
  private updateItemSelectionCount() {
    this.itemsSelectionCount = 0;
    if (this.data && this.data.length > 0) {
      this.data.forEach(function (item) {
        if (item[this.ITEM_SPECIFIC_SELECTION_PROPERTY]) {
          this.itemsSelectionCount++;
        }
      }.bind(this));
    }
  }

  truncate(showValue: boolean) {
    this.tooltipText = this.tableTitle;
    this.tooltipShow = showValue;
  }

  isUpperRight(): boolean {
    return this.addButtonPlacement == AddButtonPlacementEnum.upperRightCorner;
  }

  isLowerLeft(): boolean {
    return this.addButtonPlacement == AddButtonPlacementEnum.lowLeftCorner;
  }

  /**
   * Apply custom css class for each row
   * @param item
   */
  itemCustomizeRowClass(item: any) {
    let ngClass = {'single-row-selected': get(item, this.ITEM_SPECIFIC_SELECTION_PROPERTY)};


    if(this.customizeRowClassConfig && this.availableCustomClassBasedOn){
      let tempClass = get(this.customizeRowClassConfig, get(item, this.availableCustomClassBasedOn));
      if(tempClass){
        ngClass[tempClass] = true;
      }
    }
    //This section is added to enhance this capability by formula ja
    else if(this.customizeRowClassConfig) {
      for (let formula in this.customizeRowClassConfig) {
        if (FormulaService.evaluateFormula(formula, item)) {

          let tempClass = get(this.customizeRowClassConfig, formula);
          if (tempClass) {
            ngClass[tempClass] = true;
          }
        }
      }
    }
    return ngClass;
  }

  /**
   * Emit row click on table
   * @param item
   */
  emitClickItem(item: any) {
    this.itemClickEmitter.emit({item: item});
  }
}

class DynamicFormTableValidator implements AsyncValidator {
  constructor(
    private validationCallback: () => boolean,
    private message:string = ''
  ) {
  }

  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    return this.validationCallback()
      ? of(null)
      : of({...control.errors, error: {message: this.message}})
  }

  registerOnValidatorChange?(fn: () => void): void {
    throw new Error('Method not implemented.');
  }
}
